import { AddShoppingCartOutlined } from "@mui/icons-material";
import {
  Button,
  Card,
  CardActions,
  CardContent,
  CardMedia,
  Rating,
  Typography,
  CardActionArea
} from "@mui/material";
import React from "react";
import "./ProductCard.css";
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';

const ProductCard = ({ product, handleAddToCart }) => {
  
  return (
    <Card className="card" style={{marginTop:"1%"}}>
      <CardActionArea>
        <CardMedia
          component="img"
          height="140"
          image={product.image}
          alt="dummy product"
        />
        <CardContent>
          <Typography component="legend">{product.name}</Typography>
          <Typography component="legend">${product.cost}</Typography>
          <Rating name="read-only" value={product.rating} readOnly />
        </CardContent>

        </CardActionArea>
      <div className="flex">
        {/* <Rating name="read-only" value={product.rating} readOnly /> */}
        <Button variant="contained" 
        style={{margin:"5px"}}
        className="card-button"
        onClick={handleAddToCart}
        >
            <AddShoppingCartOutlined/>
            ADD TO CART
        </Button>
        </div>
    </Card>
  );
};

export default ProductCard;
